import type { ReactNode } from 'react'
import { useFadeIn } from '@/hooks/useFadeIn.js'
import css from './common.module.css'

interface FadeInProps {
  children: ReactNode
  className?: string
  style?: React.CSSProperties
  /** CSS duration 값 (e.g. '300ms', '600ms') */
  duration?: string
}

export function FadeIn({ children, className, style, duration }: FadeInProps) {
  const { ref, isVisible } = useFadeIn()

  const classes = [css.fadeIn, isVisible && css.fadeInVisible, className].filter(Boolean).join(' ')

  const mergedStyle = duration
    ? { ...style, '--fade-duration': duration } as React.CSSProperties
    : style

  return (
    <div ref={ref} className={classes} style={mergedStyle}>
      {children}
    </div>
  )
}
